export const LOAD_REQUESTED = "DASHBOARD/LOAD_REQUESTED";
export const LOAD_SUCCESS = "DASHBOARD/LOAD_SUCCESS";
export const LOAD_FAIL = "DASHBOARD/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoaddashboard = data => ({ type: LOAD_REQUESTED, data });
export const successLoaddashboard = data => ({ type: LOAD_SUCCESS, data });
export const failLoaddashboard = data => ({ type: LOAD_FAIL, data });
